import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal, Select } from 'antd'
import Loader from '../../pages/pages/loader'
import {
  useCreateGroupMutation,
  useUpdateGroupMutation,
} from '../../redux/apis/usersManagement/users/uMUsersApiSlice'
import GroupDropdown from '../GroupDropdown'
import PermissionsDropdown from '../PermissionsDropdown'

const EditCreateGroups = ({ state, open, setOpen, record }) => {
  const [
    updateUser,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateGroupMutation()
  const [
    addUser,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateGroupMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: record?.name,
      model_permissions: record?.model_permissions || null,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      name: Yup.string().required('Please Enter Group Name'),
    }),

    onSubmit: async values => {
      const formData = new FormData()
      const payload = { ...values }
      if (!payload.password) {
        delete payload.password
      }

      for (let key in payload) {
        formData.append(key, payload[key])
      }

      try {
        if (state === 'edit') {
          await updateUser({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addUser(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('Group created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('Group updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])
  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit Group` : 'Create Group'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />

      <div className=' mb-3'>
        <label className="form-label">Name</label>
        <Input
          type='text'
          name='name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.name}
        />
        {validation.touched.name && validation.errors.name ? (
          <p className='text-danger'>{validation.errors.name}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <PermissionsDropdown
          onChange={value => validation.setFieldValue('model_permissions', value)}
          onBlur={validation.handleBlur}
          value={validation.values.model_permissions}
          validation={validation}
          mode='multiple'
        />
        {validation.touched.model_permissions && validation.errors.model_permissions ? (
          <p className='text-danger'>{validation.errors.model_permissions}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateGroups
